/* eslint-disable no-shadow */
export default function flatten (arr) {
  return arr.reduce((acc, arr) => [...acc, ...arr], [])
}
